import FormattedPrice from "../FormattedPrice";
import styles from "./index.css";
import PropTypes from "prop-types";
import content from "app-content";

const OriginalPrice = ({ originalPrice, isOutlet }) => (
  <span className={styles.originalPrice}>
    {isOutlet && <span>{content.generic_price_rrp}</span>}
    <FormattedPrice value={originalPrice} />
  </span>
);

OriginalPrice.propTypes = {
  originalPrice: PropTypes.number,
  isOutlet: PropTypes.bool.isRequired
};

export default OriginalPrice;
